<template>
	<div>
		<Start @open-game="openGame"/>
    <transition name="game">
      <Game v-if="showGame" />
    </transition>
	</div>
</template>
<script>
import Start from "./components/Start.vue";
import Game from "./components/Game.vue";
export default {
  data: function() {
    return {
      showGame: false
    }
  },
  mounted() {
    this.bindGameEvent();
  },
	components: {
		Start,
		Game,
	},
  methods: {
    bindGameEvent: function () {
			window.addEventListener("keydown", (e) => {
				if (e.key == "Enter") {
					this.openGame();
				}
			});
		},
    openGame: function() {
      this.showGame = true;
    }
  }
};
</script>
<style lang="scss">
@font-face {
	font-family: "Press Start 2P";
	src: url("~@/assets/fonts/PressStart2P-Regular.woff2") format("woff2");
	font-weight: normal;
	font-style: normal;
	font-display: swap;
}
html {
	font-family: "Press Start 2P", cursive;
}
.game-enter-active {
  animation: game-in .5s steps(6);
}
@keyframes game-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
